import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const DocumentsApi = createApi({
  reducerPath: "DocumentsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_BASE_URL}/blob`,
    prepareHeaders: (headers, { getState }) => {
      const { accessToken } = getState().user.tokens;

      if (accessToken) {
        headers.set("authorization", `Bearer ${accessToken}`);
      }

      headers.set("x-api-key", process.env.REACT_APP_SERVER_API_KEY);
      headers.set("Content-Type", "application/json");

      return headers;
    },
  }),
  endpoints: (build) => ({
    getPropertyDocuments: build.query({
      query: ({ id, propertyId, saleId, saleType, state, county, auctionDate }) => ({
        url: `/documents/property`,
        method: "POST",
        body: { id, propertyId, saleId, saleType, state, county, auctionDate },
      }),
    }),
    getSB156Documents: build.query({
      query: () => ({
        url: `/documents/sb156`,
        method: "GET",
      }),
    }),
    getDownloadDocument: build.query({
      query: ({ documentName, containerName }) => ({
        url: `/container/${containerName}/blob/${documentName}`,
        method: "GET",
        responseHandler: async (response) => await response.blob(),
      }),
    }),
  }),
});

export const { useLazyGetPropertyDocumentsQuery, useGetSB156DocumentsQuery, useLazyGetDownloadDocumentQuery } =
  DocumentsApi;
